// extracted by mini-css-extract-plugin
module.exports = {"list-container":"styles_list-container__apQBJ","first-ul":"styles_first-ul__2YvrZ","ul":"styles_ul__2PPEl","heading":"styles_heading__1-Lry","list-item":"styles_list-item__292WT"};